import {formatTons, useTranslation} from '@hconnect/uikit'
import {Box} from '@mui/material'

import {DatetimeValueChartYLabels} from '../../../../../shared/components/d3chart/DatetimeValueChartYLabels'
import {LinearScaleFn} from '../../../../../shared/helpers/scale'

interface OptimizerStockLevelsChartLabelsProps {
  storageCapacity: number
  yScale: LinearScaleFn
}

export const OptimizerStockLevelsChartLabels: React.FC<OptimizerStockLevelsChartLabelsProps> = ({
  storageCapacity,
  yScale
}) => {
  const {
    i18n: {language}
  } = useTranslation()

  const chartYSteps = [0, storageCapacity]

  return (
    <Box
      sx={{
        width: ({spacing}) => spacing(6),
        pr: 0.5
      }}
    >
      <DatetimeValueChartYLabels
        ySteps={chartYSteps}
        yScale={yScale}
        yStepsFormatter={(step, index) =>
          formatTons(Number(step), language) + (index === chartYSteps.length - 1 ? ' (max)' : '')
        }
      />
    </Box>
  )
}
